export const Nav = ({ scrollToSection }) => (
  <nav className="nav" data-testid="main-navigation">
    <div className="logo" data-testid="brand-logo">
      Vartalab
    </div>
    <div className="nav-links" data-testid="navigation-links">
      <button
        className="nav-link"
        onClick={() => scrollToSection("leaders")}
        data-testid="nav-leaders-link"
      >
        Leaders
      </button>
      <button
        className="nav-link"
        onClick={() => scrollToSection("students")}
        data-testid="nav-students-link"
      >
        Students
      </button>
      <button
        className="nav-link"
        onClick={() => scrollToSection("professionals")}
        data-testid="nav-professionals-link"
      >
        Professionals
      </button>
      <button
        className="nav-link"
        onClick={() => scrollToSection("team")}
        data-testid="nav-team-link"
      >
        Team
      </button>
      <button
        className="nav-link"
        onClick={() => scrollToSection("contact")}
        data-testid="nav-contact-link"
      >
        Book a Call
      </button>
    </div>
  </nav>
);
